<template>
  <div>
    <MainNavigation :routeIndex="routeIndex"/>
    <NotificationBar msg-text="Looks like it's your first time logging in." />
    <div>
      <h3>Getting Started</h3>
      <p>How to set up your first class:</p>
      <div class="video-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/S6vRLZ7VWAQ"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <p><a href="https://drive.google.com/drive/folders/1iL6sDHy7kvAOLlld51yFLW70_34s2ZE4">Download the Teacher guide as a PDF</a></p>
      <button @click="goToAddClass">Next</button>
    </div>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";
export default {
  name: "Tutorial",
  components: {
    MainNavigation,
    NotificationBar,
  },
  props: ["routeIndex"],
  methods: {
    goToAddClass: function () {
      this.$router.push({ name: "add-class" });
    },
  },
};
</script>

<style>
.video-wrapper {
  position: relative;
  padding-top: 56.25%;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>